"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const dayjs_1 = __importDefault(require("rc-picker/lib/generate/dayjs"));
const generatePicker_1 = __importDefault(require("antd/lib/date-picker/generatePicker"));
const DayjsDatePicker = (0, generatePicker_1.default)(dayjs_1.default);
exports.default = DayjsDatePicker;
